export default {
  meta: {
    title: '备选址详情',
    parentPath: ['/storemanage'], // 默认展开的菜单
    url: '/storemanage/alternative', // 埋点用，记录所属模块
    breadcrumbs: {
      // 父级面包屑
      path: ['/storemanage/alternative'],
      name: ['备选址管理'],
    },
  },
};
